import { $authHost, $host } from './index.js'
import jwt_decode from 'jwt-decode'

export const getWalletAddress = async (symbol, amount, cpu, language_id) => {
    const {data} = await $authHost.post('api/wallet/get/address', {
      symbol, amount, cpu, language_id
    })
    return data
}